import React, { } from 'react'
import '../admin.css'
import { Typography } from 'antd'
import { useNavigate } from 'react-router-dom';
import ClaimsList from '../../../containers/claims-list/claims-list';
import LilyButton from '../../../components/button/lily-button';
import BackButton from '../../../components/button/back-button';

const ClaimsListPage = () => {
    const navigate = useNavigate();
    const { Text } = Typography;
    const cusTableSetting = {
        tableClassName: "cus-table-list",
        bordered: false,
        pagination: {
            showLessItems: true,
            showSizeChanger: false,
            pageSize: 30,
        },
        locale: {
            emptyText: (
                <div className='pt-2' style={{ minHeight: '285px' }}>
                    <Text style={{ color: 'var(--deactivated-color)', fontWeight: 500 }}>
                        You don’t have any claims yet! Click “Submit a Claim” to get started.
                    </Text>
                </div>
            )
        },
    }

    const renderTableHeader = () => {
        return <div className='w-100 d-flex align-items-center justify-content-end mb-3'>
            <LilyButton
                onClick={() => navigate('/claims-processing/submission')}
                text='Submit a Claim'
            />
        </div>
    }

    return (
        <div className='user-setting-layout gap-3'>
            <div className='w-100'>
                <BackButton path='/dashboard' />
            </div>
            <ClaimsList cusTableSetting={cusTableSetting} renderTableHeader={renderTableHeader} />
        </div>
    )
}

export default ClaimsListPage